<template>
  <v-sheet :width="'100%'" :elevation="4">
    <v-container>
      <div v-for="application in applications" v-bind:key="application.name">
        <v-btn
          v-if="application.type == 'link'"
          target="_blank"
          :href="application.link"
          width="100%"
          text
          class="mt-2"
        >
          {{ application.name }}
        </v-btn>
        <v-dialog v-else v-model="application.dialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn width="100%" text class="mt-2" v-bind="attrs" v-on="on">
              {{ application.name }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline justify-center lighten-2">
              <p v-html="application.content"></p>
              <a
                target="_blank"
                v-if="application.link"
                :href="application.link"
                >{{ application.link }}</a
              >
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="application.dialog = false"
                >I accept</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: "ApplicationTab",
  data() {
    return {
      dialog: false,
      dialog2: false,
      apiUrl: process.env.VUE_APP_API_LINK + "/pdf/ldb.pdf",
      applications: [
        {
          type: "dialog",
          name: "Accendo / CVS Health",
          content: 'Click <a style="text-decoration: underline !important;" target="_blank" href="https://www.aetnaseniorproducts.com/ssi/index.html">here</a>  and go to the agent login page.',
          link:
            "",
          dialog: false,
        },
        {
          type: "link",
          name: "AIG Quick Ticket Term",
          content: "",
          link:
            "https://live.cloud.api.aig.com/life/connext-security/public/login",
          dialog: false,
        },
        {
          type: "link",
          name: "AIG GIWL FE",
          content: "",
          link: "https://www-115.aig.com/?reset=false",
          dialog: false,
        },
        {
          type: "link",
          name: "Americo",
          content: "",
          link: "https://www.americo.com",
          dialog: false,
        },
        {
          type: "link",
          name: "ANICO",
          content: "",
          link:
            "https://img.anicoweb.com/wps/portal/img/home/!ut/p/z1/04_Sj9CPykssy0xPLMnMz0vMAfIjo8zi_SxMjQwtDQx9LPyDTAwcLYMDzL38vYz9jUz0wwkpiAJKG-AAjgZA_VFgJbhMMDGEKsBjRkFuhEGmo6IiABt8qow!/dz/d5/L2dBISEvZ0FBIS9nQSEh/",
          dialog: false,
        },
        {
          type: "link",
          name: "Foresters Term",
          content: "",
          link: "https://ezbiz.foresters.com/",
          dialog: false,
        },
        {
          type: "link",
          name: "Foresters FE",
          content: "",
          link: "https://web.apptical.com/LiveApp/Login/LogOn",
          dialog: false,
        },
        {
          type: "dialog",
          name: "Liberty Bankers",
          content: `Click <a style="text-decoration: underline !important;" target="_blank" href="${process.env.VUE_APP_API_LINK + "/pdf/ldb.pdf"}">here</a>  to read required disclosures to the client, then call 844-442-9871`,
          link: "",
          dialog: false,
        },
        {
          type: "link",
          name: "MOO",
          content: "",
          link:
            "https://accounts.mutualofomaha.com/?r=https%3A%2F%2Fproducer.mutualofomaha.com%2Fenterprise%2Fmyportal%2Fhome%2Fprofile%2Fcommunications",
          dialog: false,
        },
        {
          type: "link",
          name: "Prosperity",
          content: "",
          link: "https://web.apptical.com/LiveApp/Login/LogOn",
          dialog: false,
        },
        {
          type: "dialog",
          name: "Royal Neighbors",
          content: "Call 866-281-9228",
          link: null,
          dialog: false,
        },
        {
          type: "link",
          name: "Sagicor",
          content: "",
          link: "https://agent.sagicorlifeusa.com/wps/portal",
          dialog: false,
        },
        {
          type: "link",
          name: "Great Western",
          content: "",
          link: "https://my.gwic.com/Account/Login",
          dialog: false,
        },
        {
          type: "link",
          name: "North American",
          content: "",
          link: "https://www.northamericancompany.com/naloginpage",
          dialog: false,
        },
        {
          type: "link",
          name: "Protective Life",
          content: "",
          link: "https://www.myprotective.com/",
          dialog: false,
        },
        {
          type: "link",
          name: "Ethos",
          content: "",
          link: "https://agents.ethoslife.com/login",
          dialog: false,
        },
      ],
    };
  },
  mounted() {
    this.applications.sort(function (a, b) {
      var nameA = a.name.toUpperCase();
      var nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
  },
};
</script>